import { fieldOptionsFactory, IFormSchema } from 'spark-forms';
import { SubSettingsOverrides } from '../../api/generated/data-contracts';
import { settingsOverridesFieldSchema } from '../Configuration/config/components/OverrideSettings/overview/schemas/settingsOverridesFieldSchema';

export const userOverridesSchema = (fieldsWhitelist?: string[]) : IFormSchema<SubSettingsOverrides> => ({
    fields: {
        overrides: fieldOptionsFactory.formItem({
            displayName: 'Overrides',
            config: {
                schema: {
					schema: settingsOverridesFieldSchema(fieldsWhitelist),
				}
            }
        }),
    },
});
